// extracted by mini-css-extract-plugin
export var tipSection = "style-module--tip-section--aeeeb";
export var tipSection__label = "style-module--tip-section__label--cd35d";